(function(){
  /**
   * Returns a line item object from the list of line items
   * 
   * @param {number|string} variantId
   * @param {array} lineItems
   * 
   * @return {object} - Returns the raw object of the variant as by default objects in alpine are javascript proxies.
   */
  function getLineItemByVariantId(variantId, lineItems) {
    const variant = lineItems.find((v) => v.variantId === variantId);
    return Alpine.raw(variant);
  };

  /**
   * This returns the existing customer postcode and state from localstorage
   * 
   * @return {object} - The objec that contains both postcode and state
   */
  function getCustomerShippingLocationToLocalStorage() {
    const postCode = localStorage.getItem("BBShippingPostCode");
    const state = localStorage.getItem("BBShippingState");


    return {
      postCode,
      state
    }
  }

  /**
   * This function returns the state given the postcode
   * Source: https://www.spidersoft.com.au/2018/australian-postcode-to-state-conversion/
   * 
   * @param {string} state - The state of the postcode
   * @param {string|number} postCode - The postcode
   * 
   * @return {void} 
   */
  function setCustomerShippingLocationToLocalStorage(state, postCode) {
    localStorage.setItem("BBShippingPostCode", postCode);
    localStorage.setItem("BBShippingState", state);
  }

  /**
   * This function processes/formats the shipping rates response into a
   * format that our code requires. 
   * 
   * @param {number|string} postcode - The postcode being requested.
   * 
   * @return {array} - Array of formatted shipping rates for display to the front-end
   */
  function processShippingRates(shippingRates) {
    const shippingRateOverrides = window.shippingEstimateSettings.overrides;

    return Array.isArray(shippingRates) ? shippingRates.map(function(shippingRate) {
      
      const shippingRateOverride = shippingRateOverrides.find((shippingRateOverride) => {
        const shippingRateOverrideTitle = shippingRateOverride.title;
        const shippingRateOverrideTitleLowerCase = shippingRateOverrideTitle ? shippingRateOverrideTitle.toLowerCase() : "";

        return shippingRate.name.toLowerCase().includes(shippingRateOverrideTitleLowerCase);
      });

      return {
        name: shippingRate.name,
        description: shippingRate.description,
        // extraDescription: shippingRateOverride && shippingRateOverride.message,
        extraDescription: '',
        icon: shippingRateOverride && shippingRateOverride.icon,
        price: returnShippingDiscount(shippingRate.price)
      }
    }) : []
  }


  /**
   * This function returns the state given the postcode
   * Source: https://www.spidersoft.com.au/2018/australian-postcode-to-state-conversion/
   * 
   * @param {number|string} postcode - The postcode being requested.
   * 
   * @return {string} Returns the corresponding state, given the postcode. Returns blank string if invalid.
   */
  function returnState(postcode) {
    var postcode = parseInt(postcode, 10);
    if ((postcode >= 1000 && postcode <=1999) || (postcode >= 2000 && postcode <= 2599) || (postcode >=2619 && postcode <= 2899) || (postcode >= 2921 && postcode <= 2999)){
        return 'NSW';
    } else if ((postcode >= 200 && postcode <= 299) || (postcode >= 2600 && postcode <= 2618) || (postcode >= 2900 && postcode <= 2920)) {
        return 'ACT';
    } else if ((postcode >= 3000 && postcode <= 3999) || (postcode >= 8000 && postcode <= 8999)) {
        return 'VIC';
    } else if ((postcode >= 4000 && postcode <= 4999) || (postcode >= 9000 && postcode <= 9999)) {
        return 'QLD';
    } else if ((postcode >= 5000 && postcode <= 5799) || (postcode >= 5800 && postcode <= 5999)) {
        return 'SA';
    } else if ((postcode >= 6000 && postcode <= 6797) || (postcode >= 6800 && postcode <= 6999)) {
        return 'WA';
    } else if ((postcode >= 7000 && postcode <= 7799) || (postcode >= 7800 && postcode <=7999)) {
        return 'TAS';
    } else if ((postcode >= 800 && postcode <= 899) || (postcode >= 900 && postcode <= 999)) {
        return 'NT';
    }

    return '';
  }

  function returnShippingDiscount(deliveryOptionAmount) {
    // #If rate = 99.90 make it $49.95 (50% off)
    if(+deliveryOptionAmount >= 99 
          && (Math.round( deliveryOptionAmount * 100 ) % 100) == 90) {
      selectedDiscount = {};
      // #50% off
      return 49.95;

    // #If rate = $74.85 make it $49.95
    } else if (+deliveryOptionAmount >= 74 
      && (Math.round( deliveryOptionAmount * 100 ) % 100) == 85) {
      selectedDiscount = {};
      // #Deduct 24.9 from shipping rate price
      return 49.95;
      
    // #If rate = $66.45 make it $49.95
    } else if (+deliveryOptionAmount >= 66 
      && (Math.round( deliveryOptionAmount * 100 ) % 100) == 45) {
      selectedDiscount = {};
      // #Deduct 16.5 from shipping rate price
      return 49.95;
      
    // #If rate = $61.45 make it $49.95
    } else if (+deliveryOptionAmount >= 61 
      && (Math.round( deliveryOptionAmount * 100 ) % 100) == 45) {
      selectedDiscount = {};
      // #Deduct 11.5 from shipping rate price
      return 49.95;

      // #If rate = $60.45 make it $49.95
    } else if (+deliveryOptionAmount >= 60 
      && (Math.round( deliveryOptionAmount * 100 ) % 100) == 45) {
      selectedDiscount = {};
      // #Deduct 10.5 from shipping rate price
      return 49.95;

      // #If rate = $49.8 make it $24.90
    } else if (+deliveryOptionAmount >= 49 
      && (Math.round( deliveryOptionAmount * 100 ) % 100) == 80) {
      selectedDiscount = {};
      // #50% off
      return 24.90;

      // If rate = $41.40 make it $24.90
    } else if (+deliveryOptionAmount >= 41 
      && (Math.round( deliveryOptionAmount * 100 ) % 100) == 40) {
      selectedDiscount = {};
      // #Deduct 16.5 from shipping rate price
      return 24.90;

      // If rate = $39.40 make it $24.50
    } else if (+deliveryOptionAmount >= 39 
      && (Math.round( deliveryOptionAmount * 100 ) % 100) == 40) {
      selectedDiscount = {};
      // #Deduct 14.9 from shipping rate price
      return 24.50;

      // If rate = $36.40 make it $24.90
    } else if (+deliveryOptionAmount >= 36 
      && (Math.round( deliveryOptionAmount * 100 ) % 100) == 40) {
      selectedDiscount = {};
      // #Deduct 11.5 from shipping rate price
      return 24.90;

      // If rate = $35.40 make it $24.90
    } else if (+deliveryOptionAmount >= 35 
      && (Math.round( deliveryOptionAmount * 100 ) % 100) == 40) {
      selectedDiscount = {};
      // #Deduct 10.5 from shipping rate price
      return 24.90;

      // If rate = $33.00 make it $16.50
    } else if (+deliveryOptionAmount >= 33 
      && (Math.round( deliveryOptionAmount * 100 ) % 100) == 0) {
      selectedDiscount = {};
      // #50% off
      return 16.50;

      // If rate = $23.00 make it $11.50
    } else if (+deliveryOptionAmount >= 23 
      && (Math.round( deliveryOptionAmount * 100 ) % 100) == 0) {
      selectedDiscount = {};
      // #50% off
      return 11.50;

      // If rate = $21.00 make it $10.50
    } else if (+deliveryOptionAmount >= 21 
      && (Math.round( deliveryOptionAmount * 100 ) % 100) == 0) {
      selectedDiscount = {};
      // #50% off
      return 10.50;
    } else {
      return +deliveryOptionAmount
    }
  }


  document.addEventListener('alpine:init', () => {
    const delayedDispatch = Alpine.debounce(function(payload){

      SMCart.dispatch(payload);
    }, 750);
    
    Alpine.data('cartLineItems', function(initialValues) {
      return {
        prevCart: Alpine.raw(initialValues.cart),
        prevLineItems: Alpine.raw(initialValues.lineItems),
        cart: {
          ...initialValues.cart,
          totalPrice: initialValues.cart.totalPrice / 100 // shopify will initially give cents
        },
        isSpendProgressBarActive: window.spendProgressBar.showSpendProgress,
        isSpendProgressPickup: initialValues.spendProgressPickup === true,
        spendProgressPreferenceListener: null,
        init() {
          this.syncSpendProgressPreference();
          this.spendProgressPreferenceListener = () => this.syncSpendProgressPreference();
          document.addEventListener('deliveryPreference:changed', this.spendProgressPreferenceListener);
        },
        destroy() {
          document.removeEventListener('deliveryPreference:changed', this.spendProgressPreferenceListener);
        },
        syncSpendProgressPreference() {
          // Storage is written before the preference event. Missing/unreadable
          // storage must not turn a server-rendered pickup cart into delivery.
          try {
            const stored = localStorage.getItem('deliveryPreference');
            const preference = stored ? JSON.parse(stored) : null;
            const type = preference && preference.deliveryType;
            if (type === 'STORE' || type === 'DELIVERY') {
              this.isSpendProgressPickup = type === 'STORE';
            }
          } catch (error) {
            // Keep the server/last-known state when browser storage is unavailable.
          }
        },
        spendProgressBar: initialValues.spendProgressBar,
        lineItems: initialValues.lineItems,
        uiState: {
          isCartChanging: false
        },
        recomputeCartTotals() {
          let computedTotalPrice = this.lineItems.reduce((prev, next) => {
            return prev + next.finalLinePrice
          }, 0);
          
          let totalPrice = math.round(math.round(computedTotalPrice, 3), 2);

          let totalPriceWithFormat = `$${math.format(totalPrice, { notation: 'fixed', precision: 2 })}`;

          this.cart = {
            totalPrice: totalPrice,
            totalPriceWithFormat: totalPriceWithFormat
          }
        },
        recomputeLineItemTotals() {
          this.lineItems = this.lineItems.map(function(lineItem) {

            const computedLinePrice = lineItem.product.price * lineItem.quantity;

            let finalLinePrice = math.round(math.round(computedLinePrice, 3), 2);

            let finalLinePriceWithFormat = `$${math.format(finalLinePrice, { notation: 'fixed', precision: 2 })}`;

            return {
              ...Alpine.raw(lineItem),
              finalLinePrice: finalLinePrice,
              finalLinePriceWithFormat: finalLinePriceWithFormat
            }
          });
          
        },
        /**
         * This is the main function that process all updates to the spendProgressbar 
         */
        updateSpendProgress() {
          this.syncSpendProgressPreference();
          if (!window.spendProgressBar) {
            return;
          }
      
          const { totalPrice } = this.cart;
          const { tiers } = window.spendProgressBar;
          this.spendProgressBar.messages = [];
      
          const largestTier = tiers.reduce((max, tier) => {            
            return parseFloat(tier.threshold) >= parseFloat(max.threshold) ? tier : max;
          }, { threshold: 0 });

          this.spendProgressBar.maxIcon = largestTier.tier_icon;
          this.spendProgressBar.currentPercent = largestTier.threshold > 0 ? ((totalPrice / largestTier.threshold) * 100) : 0;
          this.spendProgressBar.currentThreshold = largestTier.threshold;
          this.spendProgressBar.maxThreshold = largestTier.threshold;
          this.spendProgressBar.progressMessage = "";
          this.spendProgressBar.successMessage = "";


          this.spendProgressBar.activeIcon = '';

          for (const tier of tiers) {
            const threshold = tier.threshold;            

            const updateWithDiff = text => text.replace('[difference]', '<strong>$' + (threshold - totalPrice).toFixed(2) + '</strong>')            

            if (threshold >= totalPrice && this.spendProgressBar.progressMessage == "") {              
              this.spendProgressBar.currentPercent = ((totalPrice / largestTier.threshold) * 100);
              this.spendProgressBar.progressMessage = updateWithDiff(tier.progress_message);
              this.spendProgressBar.currentThreshold = parseFloat(threshold).toFixed(2);

              this.spendProgressBar.activeIcon = tier.tier_icon;
            } else if (threshold < totalPrice) {
              this.spendProgressBar.successMessage = updateWithDiff(tier.success_message);
            }
          }
        },
        onSMCartInitialized(e) {     
          this.updateSpendProgress();          
        },
        onCartChangeFinish(e) {
          const status = e.detail.status;

          this.uiState.isCartChanging = false;

          if(status === 'ERROR') {
            console.error("Something went wrong updating the cart, please try again.")
          } else {}

        },
        onCartChangeFinishForSpendProgress(e) {

          const status = e.detail.status;
          const source = e.detail.event.source;
          const action = e.detail.event.action;


          this.uiState.isCartChanging = false;

          if(status === 'ERROR') {
            alert("Something went wrong updating the cart, please try again.")
          } else {
            // Create a plugin to update cart based on changes in line items
            if(source == 'cart.js') {
              this.updateLineItemFromExternalSource(action);
            }

            this.recomputeLineItemTotals();
            this.recomputeCartTotals();
            this.updateSpendProgress();
          }

        },
        onAddToCartForSpendProgress(e) {
          const status = e.detail.status;
          const source = e.detail.event.source;
          const cartLineItems = e.detail.event.cartUpdatesAll.items;
          const cartLineItemsModified = Array.isArray(cartLineItems) ? cartLineItems.map((lineItem) => {
            return {
              ...lineItem,
              price: lineItem.price / 100
            }
          }) : []

          if(status === 'ERROR') {
            alert("Something went wrong updating the cart, please try again.")
          } else {
            // Create a plugin to update cart based on changes in line items
            if(source == 'product-form.js') {
              this.updateLineItemsByAddToCart(cartLineItemsModified);
            }

            this.recomputeLineItemTotals();
            this.recomputeCartTotals();
            this.updateSpendProgress();
          }

        },
        /**
         * All items below 
         */
        onQuantityChange(variantId) {
          return (e) => {
            const variant = getLineItemByVariantId(variantId, this.lineItems);
            const payload = {
              type: "changeCart",
              id: variant.key,
              quantity: +variant.quantity
            };

            this.uiState.isCartChanging = true;

            if(+variant.quantity < 1) {
              this.deleteLocalLineItemByVariantId(variantId);
            }

            this.recomputeLineItemTotals();
            this.recomputeCartTotals();
            this.updateSpendProgress();

            // Call API
            SMCart.dispatch(payload);
          }
        },
        /**
         * Not being used right now as alpine-cart-items.liquid is not used for the cart.
         */
        onSingularQuantityChange(variantId, quantityChange) {
          
          return (e) => {

            this.lineItems = this.lineItems.map(function(lineItem) {

              if(lineItem.variantId == variantId) {
                return {
                  ...lineItem,
                  quantity: +lineItem.quantity + quantityChange
                }

              } 

              return lineItem

            });

            const variant = getLineItemByVariantId(variantId, this.lineItems);


            const payload = {
              type: "changeCart",
              id: variant.key,
              quantity: +variant.quantity
            };


            if(+variant.quantity < 1) {
              this.deleteLocalLineItemByVariantId(variantId);
            }

            this.uiState.isCartChanging = true;


            this.recomputeLineItemTotals();
            this.recomputeCartTotals();
            this.updateSpendProgress();

            // Call API after a few miliseconds
            delayedDispatch(payload);
        
          }
        
        },
        /**
         * Not being used right now as alpine-cart-items.liquid is not used for the cart.
         */
        onCartDelete(variantId) {
          return (e) => {

            const variant = getLineItemByVariantId(variantId, this.lineItems);
            const payload = {
              type: "changeCart",
              id: variant.key,
              quantity: 0
            };
  
            this.uiState.isCartChanging = true;
            

            this.deleteLocalLineItemByVariantId(variantId);
            this.recomputeLineItemTotals();
            this.recomputeCartTotals();
            this.updateSpendProgress();
  
            // Call API
            SMCart.dispatch(payload);
          }
        },
        /**
         * Not being used right now as alpine-cart-items.liquid is not used for the cart.
         */
        deleteLocalLineItemByVariantId(variantId) {
          this.lineItems = this.lineItems.filter((lineItem) => {
            return lineItem.variantId != variantId
          });
        },
        /**
         * Not being used right now as alpine-cart-items.liquid is not used for the cart.
         */
        updateLineItemFromExternalSource(lineItemChangeAction) {

          const lineItems = Alpine.raw(this.lineItems);
          const index = +lineItemChangeAction.line - 1;
          const quantity = +lineItemChangeAction.quantity;

          const variantId = lineItems[index] ? lineItems[index].variantId : false;

          if(variantId && quantity > 0) {

            this.lineItems = this.lineItems.map(function(lineItem) {
  
              if(lineItem.variantId == variantId) {
                return {
                  ...lineItem,
                  quantity: quantity
                }
  
              }
  
              return lineItem
  
            });
            
          } else if (variantId && quantity == 0) {
            this.deleteLocalLineItemByVariantId(variantId);
          }


        },
        /**
         * Not being used right now as alpine-cart-items.liquid is not used for the cart.
         */
        updateLineItemsByAddToCart(remoteLineItems) {
          this.lineItems = remoteLineItems.map((lineItem) => {
            return {
              id: lineItem.id,
              variantId: lineItem.id,
              key: lineItem.key,
              product: {
                title: lineItem.title,
                price: +lineItem.price
              },
              finalLinePrice: +lineItem['original_line_price'],
              quantity: lineItem.quantity
            }
          })

        }
      }

    });

    /**
     * This handles most of the functions that makes alpine-shipping-estimate.liquid work
     */
    Alpine.data('shippingEstimate', function(initialValues) {
      // On page load, check localstorage if there is an existing postcode and suburb
      const { postCode, state } = getCustomerShippingLocationToLocalStorage();

      const isThereInitialFormData = postCode && state;
      const initialState = postCode && state ? {
        postCode,
        state
      } : {
        postCode: '',
        state: '',
      };

      const shippingStates = window.shippingEstimateSettings.shippingStates || "";
      const shippingStatesArray = shippingStates.split(',');

      return {
        cartItems: initialValues.initialCartItems,
        prevFormData: {
          ...initialState
        },
        formData: {
          ...initialState
        },
        message: window.shippingEstimateSettings.message,
        formState: {
          isThereInitialFormData: isThereInitialFormData,
          submitAttempts: isThereInitialFormData ? 1 : 0,
          isSubmittedOnce: isThereInitialFormData,
          isSubmitting: false,
          isFormEditing: !isThereInitialFormData,
          isFormSaved: isThereInitialFormData,
          lastSubmitResult: undefined
        },
        shippingStates: shippingStatesArray || [],
        shippingRates: [],
        isValidPostCode(postCode) {
          return /^[0-9]{4}$/.test(postCode)
        },
        /**
         * This function is used to update the cart price to include the estimated shipping rate price
         * provided for by the shipping rate widget.
         */
        updateCartPrice() {
          const cartPriceEl = document.querySelector('#main-cart-footer .totals__subtotal-value');
          const cartPriceLabelEl = document.querySelector('#main-cart-footer .totals__subtotal');
          const cartPrice = cartPriceEl ? cartPriceEl.dataset.cartOnlyPrice : null;
          const shippingRates = Alpine.raw(this.shippingRates);
          let originalPrice = cartPrice;
          let shippingRatePrice = 0;

          if(cartPrice && cartPriceLabelEl && shippingRates.length > 0) {

            shippingRatePrice = +shippingRates[0].price * 100;

            originalPrice = Shopify.formatMoney(+cartPrice + shippingRatePrice);

            cartPriceEl.innerHTML = originalPrice + ' AUD';

            cartPriceLabelEl.innerHTML = cartPriceLabelEl.dataset.estimatedCopy;

          } else if (cartPrice && cartPriceLabelEl && shippingRates.length == 0) {

            originalPrice = Shopify.formatMoney(+cartPrice);

            cartPriceEl.innerHTML = originalPrice + ' AUD';

            cartPriceLabelEl.innerHTML = cartPriceLabelEl.dataset.subtotalCopy;
          }
        },
        async onPageLoad() {

          try {
            
            if(this.formData.postCode) {
              this.formState.isSubmitting = true;
              this.formData.state = returnState(this.formData.postCode);
              
              await this.fetchShippingRateFromShopify(this.formData);
              this.updateCartPrice();
            }

          } catch(e) {
            console.error(e);
          }

          this.formState.isSubmitting = false;
        },
        async fetchShippingRateFromShopify(formData) {

          try {
            var response = await fetch(`/cart/shipping_rates.json?shipping_address%5Bzip%5D=${formData.postCode}&shipping_address%5Bcountry%5D=australia&shipping_address%5Bprovince%5D=${formData.state}`)


            if (response.status >= 400 && response.status < 600) {
              this.shippingRates = [];
              this.formState.lastSubmitResult = response.status;
            }

            var data = await response.json();

            this.shippingRates = processShippingRates(data['shipping_rates']);
            this.formState.lastSubmitResult = response.status;


            return Promise.resolve(response);
          } catch(e) {
            console.error(e);
            this.formState.lastSubmitResult = 606;

            return Promise.reject(e);
          }
        },
        async handleFormSave() {
          this.formState.isSubmitting = true;

          this.formState.submitAttempts += 1;


          /**
           * Implement a checker that checks if the form has already 
           * submitted before and if there are no changes to the form, do not submit 
           */
          try {

            if(this.isValidPostCode(this.formData.postCode)) {
              this.formData.state = returnState(this.formData.postCode);

              await this.fetchShippingRateFromShopify(this.formData)
            } 

            if(this.isValidPostCode(this.formData.postCode) && !this.formState.isSubmittedOnce) {
              this.formState.isSubmittedOnce = true;
            }

            this.updateCartPrice();
          } catch (e) {
            console.error(e);;
          }
          
          if(this.isValidPostCode(this.formData.postCode)) {
            this.formState.isFormSaved = true;

            this.formData.state = returnState(this.formData.postCode);

            setCustomerShippingLocationToLocalStorage(this.formData.state, this.formData.postCode);

            this.prevFormData = {...this.formData};
            this.formState.isFormEditing = false;
          }

          this.formState.isSubmitting = false;
        },
        async onCartChange(e) {

          const cartLineItems = e.detail.event.cartUpdates.items;

          try {
            if(Array.isArray(cartLineItems)) {
              this.cartItems = cartLineItems.length;
            }
            
            if(this.formData.postCode && this.formData.state) {
              this.formState.isSubmitting = true;
              await this.fetchShippingRateFromShopify(this.formData);
              this.updateCartPrice();
            }

          } catch(e) {
            console.error(e);
          }

          this.formState.isSubmitting = false;
        },
        handleFormCancel() {
          this.formState.isFormEditing = false;

          this.formData = {
            ...this.prevFormData
          };

        },
        handleFormOpen() {
          this.formState.isFormEditing = true;
        }
      }
    });

    /**
     * The event listeners below are events fired by SMCart which in return fires another custom event that 
     * is being watched over by various AlpineJS code in the store.
     */
    SMCart.on("changeCart", (event) => {
      if('errors' in event.cartUpdates && event.cartUpdates) {
        
        // Watched on x-on:sm-cart-change
        document.dispatchEvent(
          new CustomEvent("sm-cart-change", { detail: { 
            event: event,
            status: 'ERROR'
          }, bubbles: true }
        ));
  
      } else {

        // Watched on x-on:sm-cart-change
        document.dispatchEvent(
          new CustomEvent("sm-cart-change", { detail: { 
            event: event,
            status: 'SUCCESS'
          }, bubbles: true }
        ));

      }

    });

    SMCart.on("addToCart", (event) => {

      if('errors' in event.cartUpdates && event.cartUpdates) {
  
        document.dispatchEvent(
          // Watched on x-on:sm-cart-add
          new CustomEvent("sm-cart-add", { detail: { 
            event: event,
            status: 'ERROR'
          }, bubbles: true }
        ));
  
      } else {

        document.dispatchEvent(
          // Watched on x-on:sm-cart-add
          new CustomEvent("sm-cart-add", { detail: { 
            event: event,
            status: 'SUCCESS'
          }, bubbles: true }
        ));

      }

    });

    SMCart.on("changeCart.error", (event) => {
      document.dispatchEvent(
        // Watched on x-on:sm-cart-change
        new CustomEvent("sm-cart-change", { detail: { 
          event: event,
          status: 'SUCCESS'
        }, bubbles: true }
      ));
    });
  

    document.dispatchEvent(new CustomEvent("sm-cart-initialized"));
  });


})();